import { toast } from "react-toastify";
import { showLoader, hideLoader } from "../slices/ui/loaderSlice";
import { useTranslation } from "react-i18next";

// export const loaderMiddleware = (store) => (next) => (action) => {
//     const { t } = useTranslation()
//   // If an action is "pending", show the loader
//   if (action.type.endsWith('/pending')) {
//     store.dispatch(showLoader());
//   }
  
//   // If an action is "fulfilled" or "rejected", hide the loader
//   if (action.type.endsWith('/fulfilled') || action.type.endsWith('/rejected')) {
//     store.dispatch(hideLoader());
//   }

//   if (action.type.endsWith('/rejected')) {
//     store.dispatch(hideLoader());

//     // Access the status code from the error payload
//     const status = action.payload?.status;
//     const message = action.payload?.message || t('common.somethingWentWrong')

//     switch (status) {
//       case 400:
//         toast.error(`Bad Request: ${message}`);
//         break;
//       case 401:
//         toast.warning("Session expired. Please login again.");
//         break;
//       case 403:
//         toast.error("You don't have permission for this action.");
//         break;
//       case 404:
//         toast.error("Resource not found.");
//         break;
//       case 500:
//         toast.error(message);
//         break;
//       default:
//         toast.error(message);
//     }
//   }

//   return next(action);
// };

// export const loaderMiddleware = (store) => (next) => (action) => {

//   console.log("MY Current Action", action.type);

//   if (action.type.endsWith('/pending')) {
//     store.dispatch(showLoader());
//   }

//   if (action.type.endsWith('/fulfilled')) {
//     store.dispatch(hideLoader());

//     const isWriteAction = /create|add|update|delete|remove/i.test(action.type);
    
//     if (isWriteAction) {
//       const message = action.payload?.message || "Operation successful!";
//       toast.success(message);
//     }
//   }
  
//   if (action.type.endsWith('/rejected')) {
//     store.dispatch(hideLoader());
//     const errorMsg = action.payload?.response?.data?.message || 
//                      action.payload?.message || 
//                      "An unexpected error occurred";
//                      console.log(action);
                     

//     toast.error(errorMsg);
//   }
//   return next(action);
// };

export const loaderMiddleware = (store) => (next) => (action) => {
  const skipLoader = action.meta?.arg?.skipLoader
  

  if (action.type.endsWith('/pending') && !skipLoader) {
    store.dispatch(showLoader());
  }

  if (action.type.endsWith('/fulfilled') && !skipLoader) {
    store.dispatch(hideLoader());

    const isWriteAction = /create|add|update|delete|remove/i.test(action.type);

    if (isWriteAction) {
      const message = action?.payload?.message || 'Operation successful!';
      toast.success(message);
    }
  }

  if (action.type.endsWith('/rejected') && !skipLoader) {
    store.dispatch(hideLoader());
    
    let nextError = action?.payload?.response?.data?.error?.message
    const errorMsg =
      nextError ||
      action?.payload?.response?.data?.message ||
      action?.payload?.message ||
      'An unexpected error occurred';
    
    toast.error(errorMsg);
  }
  return next(action);
};
